const LoadingStatus = {
  notStart: "notStart",
  error: "error",
  loaded: "loaded"
};

export default LoadingStatus;
